module.exports = __webpack_public_path__ + "static/img/Permiso(5).982e959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(5).jpg
// module id = cQ2t
// module chunks = 0